import script from "./BookCardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./BookCardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./BookCardSkeleton.vue?vue&type=style&index=0&id=1905f628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1905f628"]])

export default __exports__